import React from 'react'

const Yahoo = ({ size = 24, color = '#3076D0', ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		{...props}
	>
		<path
			d="M12.948 13.277L13.0834 20.5C12.6529 20.4251 12.2883 20.3876 11.9897 20.3876C11.7049 20.3876 11.3404 20.4251 10.8959 20.5L11.0313 13.277C10.7536 12.8071 10.1685 11.8008 9.27612 10.2581C8.38376 8.71544 7.63203 7.4401 7.02091 6.43209C6.4098 5.42408 5.78133 4.44671 5.1355 3.5C5.53828 3.60216 5.91328 3.65325 6.2605 3.65325C6.56605 3.65325 6.95147 3.60216 7.41675 3.5C7.85425 4.25601 8.31779 5.03756 8.80737 5.84465C9.29696 6.65174 9.87682 7.59335 10.547 8.66947C11.2171 9.74559 11.698 10.5186 11.9897 10.9886C12.2466 10.5731 12.6268 9.96865 13.1303 9.17518C13.6338 8.38171 14.0417 7.73468 14.3542 7.23407C14.6667 6.73347 15.0313 6.13411 15.448 5.436C15.8647 4.73788 16.2362 4.09255 16.5626 3.5C16.9376 3.59535 17.3091 3.64303 17.6772 3.64303C18.0661 3.64303 18.4619 3.59535 18.8647 3.5C18.6702 3.76562 18.4619 4.06701 18.2397 4.40415C18.0174 4.74129 17.8456 5.00861 17.724 5.20613C17.6025 5.40365 17.4063 5.73057 17.1355 6.1869C16.8647 6.64323 16.6945 6.92929 16.6251 7.04507C15.6112 8.73417 14.3855 10.8115 12.948 13.277Z"
			fill={color}
		/>
	</svg>
)

export default Yahoo;
